import { render, staticRenderFns } from "./supplements.vue?vue&type=template&id=64507695&scoped=true&"
import script from "./supplements.vue?vue&type=script&lang=js&"
export * from "./supplements.vue?vue&type=script&lang=js&"
import style0 from "./supplements.vue?vue&type=style&index=0&id=64507695&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64507695",
  null
  
)

export default component.exports